// COMPONENTS
import Dropdown from "./dropdown";

const NUMBER_COMPARISONS = [
  { value: "eq", label: "Equals" },
  { value: "lt", label: "Less than" },
  { value: "gt", label: "Greater than" },
  { value: "between", label: "Between" },
];

const NumberComparisonDropdown = ({ handleChange, value, name }) => {
  return (
    <Dropdown
      handleChange={handleChange}
      value={value}
      name={name}
      options={NUMBER_COMPARISONS}
    />
  );
};

export default NumberComparisonDropdown;
